import {
  GET_EXPENSE_TYPES_REQUEST,
  GET_EXPENSE_TYPES_SUCCESS,
  GET_EXPENSE_TYPES_FAILURE,
  GET_EXPENSE_TYPE_REQUEST,
  GET_EXPENSE_TYPE_SUCCESS,
  GET_EXPENSE_TYPE_FAILURE,
  CREATE_EXPENSE_TYPE_REQUEST,
  CREATE_EXPENSE_TYPE_SUCCESS,
  CREATE_EXPENSE_TYPE_FAILURE,
  UPDATE_EXPENSE_TYPE_REQUEST,
  UPDATE_EXPENSE_TYPE_SUCCESS,
  UPDATE_EXPENSE_TYPE_FAILURE,
  DELETE_EXPENSE_TYPE_REQUEST,
  DELETE_EXPENSE_TYPE_SUCCESS,
  DELETE_EXPENSE_TYPE_FAILURE
} from '../types';

const initialState = {
  expenseTypes: [],
  currentExpenseType: null,
  loading: false,
  error: null
};

const expenseTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Expense Types
    case GET_EXPENSE_TYPES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_EXPENSE_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        expenseTypes: action.payload.data,
        error: null
      };

    case GET_EXPENSE_TYPES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Get Single Expense Type
    case GET_EXPENSE_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_EXPENSE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        currentExpenseType: action.payload.data,
        error: null
      };

    case GET_EXPENSE_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Create Expense Type
    case CREATE_EXPENSE_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case CREATE_EXPENSE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        expenseTypes: [...state.expenseTypes, action.payload.data],
        error: null
      };

    case CREATE_EXPENSE_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Update Expense Type
    case UPDATE_EXPENSE_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case UPDATE_EXPENSE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        expenseTypes: state.expenseTypes.map(expenseType =>
          expenseType.id === action.payload.data.id ? action.payload.data : expenseType
        ),
        currentExpenseType: state.currentExpenseType?.id === action.payload.data.id 
          ? action.payload.data 
          : state.currentExpenseType,
        error: null
      };

    case UPDATE_EXPENSE_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Delete Expense Type
    case DELETE_EXPENSE_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case DELETE_EXPENSE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        expenseTypes: state.expenseTypes.filter(expenseType => expenseType.id !== action.payload.id),
        currentExpenseType: state.currentExpenseType?.id === action.payload.id 
          ? null 
          : state.currentExpenseType,
        error: null
      };

    case DELETE_EXPENSE_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default expenseTypeReducer;
